// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3ynqe","question":"Question_question__3eKs4","description":"Question_description__5scx9"};